var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _g, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMadcocoLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 784.3 1040.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-60);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-69);\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath-20);\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-21);\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-24);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-23);\n      }\n\n      .cls-22 {\n        clip-path: url(#clippath-22);\n      }\n\n      .cls-23 {\n        clip-path: url(#clippath-25);\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-44);\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath-45);\n      }\n\n      .cls-26 {\n        clip-path: url(#clippath-40);\n      }\n\n      .cls-27 {\n        clip-path: url(#clippath-42);\n      }\n\n      .cls-28 {\n        clip-path: url(#clippath-41);\n      }\n\n      .cls-29 {\n        clip-path: url(#clippath-47);\n      }\n\n      .cls-30 {\n        clip-path: url(#clippath-43);\n      }\n\n      .cls-31 {\n        clip-path: url(#clippath-46);\n      }\n\n      .cls-32 {\n        clip-path: url(#clippath-48);\n      }\n\n      .cls-33 {\n        clip-path: url(#clippath-49);\n      }\n\n      .cls-34 {\n        clip-path: url(#clippath-84);\n      }\n\n      .cls-35 {\n        clip-path: url(#clippath-88);\n      }\n\n      .cls-36 {\n        clip-path: url(#clippath-86);\n      }\n\n      .cls-37 {\n        clip-path: url(#clippath-81);\n      }\n\n      .cls-38 {\n        clip-path: url(#clippath-83);\n      }\n\n      .cls-39 {\n        clip-path: url(#clippath-85);\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath-80);\n      }\n\n      .cls-41 {\n        clip-path: url(#clippath-87);\n      }\n\n      .cls-42 {\n        clip-path: url(#clippath-82);\n      }\n\n      .cls-43 {\n        clip-path: url(#clippath-98);\n      }\n\n      .cls-44 {\n        clip-path: url(#clippath-89);\n      }\n\n      .cls-45 {\n        clip-path: url(#clippath-27);\n      }\n\n      .cls-46 {\n        clip-path: url(#clippath-28);\n      }\n\n      .cls-47 {\n        clip-path: url(#clippath-26);\n      }\n\n      .cls-48 {\n        clip-path: url(#clippath-29);\n      }\n\n      .cls-49 {\n        clip-path: url(#clippath-34);\n      }\n\n      .cls-50 {\n        clip-path: url(#clippath-35);\n      }\n\n      .cls-51 {\n        clip-path: url(#clippath-36);\n      }\n\n      .cls-52 {\n        clip-path: url(#clippath-37);\n      }\n\n      .cls-53 {\n        clip-path: url(#clippath-39);\n      }\n\n      .cls-54 {\n        clip-path: url(#clippath-33);\n      }\n\n      .cls-55 {\n        clip-path: url(#clippath-32);\n      }\n\n      .cls-56 {\n        clip-path: url(#clippath-30);\n      }\n\n      .cls-57 {\n        clip-path: url(#clippath-38);\n      }\n\n      .cls-58 {\n        clip-path: url(#clippath-31);\n      }\n\n      .cls-59 {\n        clip-path: url(#clippath-95);\n      }\n\n      .cls-60 {\n        clip-path: url(#clippath-99);\n      }\n\n      .cls-61 {\n        clip-path: url(#clippath-93);\n      }\n\n      .cls-62 {\n        clip-path: url(#clippath-94);\n      }\n\n      .cls-63 {\n        clip-path: url(#clippath-91);\n      }\n\n      .cls-64 {\n        clip-path: url(#clippath-96);\n      }\n\n      .cls-65 {\n        clip-path: url(#clippath-90);\n      }\n\n      .cls-66 {\n        clip-path: url(#clippath-92);\n      }\n\n      .cls-67 {\n        clip-path: url(#clippath-97);\n      }\n\n      .cls-68 {\n        clip-path: url(#clippath-53);\n      }\n\n      .cls-69 {\n        clip-path: url(#clippath-54);\n      }\n\n      .cls-70 {\n        clip-path: url(#clippath-50);\n      }\n\n      .cls-71 {\n        clip-path: url(#clippath-51);\n      }\n\n      .cls-72 {\n        clip-path: url(#clippath-52);\n      }\n\n      .cls-73 {\n        clip-path: url(#clippath-55);\n      }\n\n      .cls-74 {\n        clip-path: url(#clippath-56);\n      }\n\n      .cls-75 {\n        clip-path: url(#clippath-57);\n      }\n\n      .cls-76 {\n        clip-path: url(#clippath-58);\n      }\n\n      .cls-77 {\n        clip-path: url(#clippath-79);\n      }\n\n      .cls-78 {\n        clip-path: url(#clippath-61);\n      }\n\n      .cls-79 {\n        clip-path: url(#clippath-64);\n      }\n\n      .cls-80 {\n        clip-path: url(#clippath-62);\n      }\n\n      .cls-81 {\n        clip-path: url(#clippath-68);\n      }\n\n      .cls-82 {\n        clip-path: url(#clippath-67);\n      }\n\n      .cls-83 {\n        clip-path: url(#clippath-73);\n      }\n\n      .cls-84 {\n        clip-path: url(#clippath-59);\n      }\n\n      .cls-85 {\n        clip-path: url(#clippath-65);\n      }\n\n      .cls-86 {\n        clip-path: url(#clippath-63);\n      }\n\n      .cls-87 {\n        clip-path: url(#clippath-66);\n      }\n\n      .cls-88 {\n        clip-path: url(#clippath-70);\n      }\n\n      .cls-89 {\n        clip-path: url(#clippath-75);\n      }\n\n      .cls-90 {\n        clip-path: url(#clippath-72);\n      }\n\n      .cls-91 {\n        clip-path: url(#clippath-78);\n      }\n\n      .cls-92 {\n        clip-path: url(#clippath-71);\n      }\n\n      .cls-93 {\n        clip-path: url(#clippath-77);\n      }\n\n      .cls-94 {\n        clip-path: url(#clippath-74);\n      }\n\n      .cls-95 {\n        clip-path: url(#clippath-76);\n      }\n\n      .cls-96 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-97 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-98 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-99 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-100 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-101 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-102 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-103 {\n        clip-path: url(#clippath-19);\n      }\n\n      .cls-104 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-105 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-3 {\n        fill: #f7a8a9;\n      }\n\n      .cls-4 {\n        fill: #2e6e58;\n      }\n\n      .cls-5 {\n        fill: #0f684f;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-106 {\n        clip-path: url(#clippath-144);\n      }\n\n      .cls-107 {\n        clip-path: url(#clippath-153);\n      }\n\n      .cls-108 {\n        clip-path: url(#clippath-157);\n      }\n\n      .cls-109 {\n        clip-path: url(#clippath-154);\n      }\n\n      .cls-110 {\n        clip-path: url(#clippath-158);\n      }\n\n      .cls-111 {\n        clip-path: url(#clippath-146);\n      }\n\n      .cls-112 {\n        clip-path: url(#clippath-142);\n      }\n\n      .cls-113 {\n        clip-path: url(#clippath-148);\n      }\n\n      .cls-114 {\n        clip-path: url(#clippath-141);\n      }\n\n      .cls-115 {\n        clip-path: url(#clippath-145);\n      }\n\n      .cls-116 {\n        clip-path: url(#clippath-143);\n      }\n\n      .cls-117 {\n        clip-path: url(#clippath-147);\n      }\n\n      .cls-118 {\n        clip-path: url(#clippath-149);\n      }\n\n      .cls-119 {\n        clip-path: url(#clippath-140);\n      }\n\n      .cls-120 {\n        clip-path: url(#clippath-151);\n      }\n\n      .cls-121 {\n        clip-path: url(#clippath-152);\n      }\n\n      .cls-122 {\n        clip-path: url(#clippath-156);\n      }\n\n      .cls-123 {\n        clip-path: url(#clippath-155);\n      }\n\n      .cls-124 {\n        clip-path: url(#clippath-159);\n      }\n\n      .cls-125 {\n        clip-path: url(#clippath-150);\n      }\n\n      .cls-126 {\n        clip-path: url(#clippath-113);\n      }\n\n      .cls-127 {\n        clip-path: url(#clippath-112);\n      }\n\n      .cls-128 {\n        clip-path: url(#clippath-111);\n      }\n\n      .cls-129 {\n        clip-path: url(#clippath-110);\n      }\n\n      .cls-130 {\n        clip-path: url(#clippath-115);\n      }\n\n      .cls-131 {\n        clip-path: url(#clippath-114);\n      }\n\n      .cls-132 {\n        clip-path: url(#clippath-116);\n      }\n\n      .cls-133 {\n        clip-path: url(#clippath-117);\n      }\n\n      .cls-134 {\n        clip-path: url(#clippath-118);\n      }\n\n      .cls-135 {\n        clip-path: url(#clippath-119);\n      }\n\n      .cls-136 {\n        clip-path: url(#clippath-105);\n      }\n\n      .cls-137 {\n        clip-path: url(#clippath-100);\n      }\n\n      .cls-138 {\n        clip-path: url(#clippath-102);\n      }\n\n      .cls-139 {\n        clip-path: url(#clippath-103);\n      }\n\n      .cls-140 {\n        clip-path: url(#clippath-107);\n      }\n\n      .cls-141 {\n        clip-path: url(#clippath-109);\n      }\n\n      .cls-142 {\n        clip-path: url(#clippath-104);\n      }\n\n      .cls-143 {\n        clip-path: url(#clippath-101);\n      }\n\n      .cls-144 {\n        clip-path: url(#clippath-108);\n      }\n\n      .cls-145 {\n        clip-path: url(#clippath-106);\n      }\n\n      .cls-146 {\n        clip-path: url(#clippath-161);\n      }\n\n      .cls-147 {\n        clip-path: url(#clippath-160);\n      }\n\n      .cls-148 {\n        clip-path: url(#clippath-136);\n      }\n\n      .cls-149 {\n        clip-path: url(#clippath-138);\n      }\n\n      .cls-150 {\n        clip-path: url(#clippath-135);\n      }\n\n      .cls-151 {\n        clip-path: url(#clippath-132);\n      }\n\n      .cls-152 {\n        clip-path: url(#clippath-137);\n      }\n\n      .cls-153 {\n        clip-path: url(#clippath-130);\n      }\n\n      .cls-154 {\n        clip-path: url(#clippath-133);\n      }\n\n      .cls-155 {\n        clip-path: url(#clippath-134);\n      }\n\n      .cls-156 {\n        clip-path: url(#clippath-139);\n      }\n\n      .cls-157 {\n        clip-path: url(#clippath-131);\n      }\n\n      .cls-158 {\n        clip-path: url(#clippath-129);\n      }\n\n      .cls-159 {\n        clip-path: url(#clippath-122);\n      }\n\n      .cls-160 {\n        clip-path: url(#clippath-126);\n      }\n\n      .cls-161 {\n        clip-path: url(#clippath-125);\n      }\n\n      .cls-162 {\n        clip-path: url(#clippath-120);\n      }\n\n      .cls-163 {\n        clip-path: url(#clippath-121);\n      }\n\n      .cls-164 {\n        clip-path: url(#clippath-123);\n      }\n\n      .cls-165 {\n        clip-path: url(#clippath-124);\n      }\n\n      .cls-166 {\n        clip-path: url(#clippath-127);\n      }\n\n      .cls-167 {\n        clip-path: url(#clippath-128);\n      }\n\n      .cls-168 {\n        clip-path: url(#clippath-162);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-66"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-69"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-73"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-76"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-80"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-81"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-82"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-83"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-84"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-85"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-86"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-87"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-88"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-90"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-91"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-92"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-93"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-94"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-95"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-97"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-98"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-99"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-100"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-102"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-103"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-104"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-105"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-106"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-107"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-108"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-109"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-110"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-111"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-112"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-113"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-114"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-115"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-116"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-117"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-118"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-119"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-120"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-121"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-123"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-124"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-125"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-126"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-127"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-128"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-129"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-130"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-131"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-132"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-133"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-134"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-135"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-136"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-137"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-138"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-141"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-142"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-144"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-146"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-147"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-148"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-150"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-151"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-152"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-153"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-154"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-155"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-156"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-157"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-158"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-159"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-160"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-161"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-162"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m725.1,324.79c.4,3,.5,6,.5,9.1,0,86.8-143.4,157.1-320.4,157.1-40.4,0-79.1-3.7-114.7-10.4-43.6-8.2-82.6-20.9-114.7-37-56.4-28.3-91.1-67.1-91.1-109.8,0-3.1.2-6.1.5-9.1C21.9,503.69,5.5,825.09,405.2,825.19h.3c399.7-.1,383.3-321.6,319.9-500.4h-.3Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m405,827.99c-144-.1-246.3-41.6-304.1-123.4-35.6-50.5-53.5-114.8-53-191.4.3-60,12.5-127,34.3-188.8l.1-.3v-.3c5.9-47.5,53.7-90.9,131.2-119l2.2-.8-31.8-180.7c-.3-2.5.3-4.6,1.7-6.6,3.9-5.6,14.6-10.7,27.1-12.9,4.2-.7,8.4-1.1,12.3-1.1,7.6,0,13.9,1.4,17.6,4,2.7,1.9,3.6,4.1,3.8,5.5l30.8,174.8,2.8-.6c39.6-8.2,81.7-12.4,125.1-12.4s85.7,4.2,125.4,12.4l2.8.6,30.8-174.6c.3-1.5,1.1-3.6,3.8-5.5,3.7-2.6,9.9-4,17.6-4,3.9,0,8.1.4,12.3,1.1,12.5,2.2,23.1,7.3,27.1,12.9,1.8,2.5,1.9,4.7,1.7,6.1l-31.9,181.2,2.2.8c76.6,27.9,124.3,70.8,130.8,117.7l.1.5.2.4c22,62.1,34.3,129.3,34.6,189.5.4,76.6-17.4,141-53,191.4-58,82-160.3,123.5-304.3,123.5h-.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m765.3,513.19c.4,77.1-17.6,142.1-53.6,193-58.3,82.6-161.4,124.5-306.3,124.5h0c2.9-.1,5.3-2.6,5.3-5.5,0-3.1-2.5-5.5-5.5-5.5h.3c141.1-.1,241.1-40.4,297.2-119.9,34.6-49,51.9-111.7,51.5-186.5-.3-50.7-9.2-106.6-25.3-159.9,1.5-6.4,2.3-12.9,2.3-19.5,0-3.3-.2-6.6-.6-9.8-.1-.6-.1-1.2-.2-1.8.1.2.2.3.2.5,22,62.4,34.4,129.9,34.7,190.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m730.6,324.19c.4,3.2.6,6.4.6,9.8,0,6.6-.8,13.1-2.3,19.5-2.7-9-5.6-17.9-8.8-26.8-.1-.4-.2-.8-.3-1.2-.3-2.5,1.2-5,3.7-5.9,2.7-1,5.7.3,6.8,2.8.1.6.2,1.2.3,1.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m730.4,322.39c-1.2-2.5-4.2-3.8-6.8-2.8-2.5.9-3.9,3.4-3.7,5.9h-.3c-5.1-44.2-50.1-84.8-123.7-111.9l2-11.1c77.8,28.3,125.8,71.8,132.5,119.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m720.1,326.69c3.1,8.8,6.1,17.8,8.8,26.8-8.6,36.7-41.5,70.5-94.7,96.6-61.3,30-142.6,46.6-229,46.6-39.9,0-78.8-3.5-115.7-10.5-43.3-8.2-83.5-21.2-116.1-37.6-51.3-25.8-83.2-58.8-91.8-94.7,2.7-9.1,5.7-18.1,8.8-27,0-.1.1-.2.1-.3.1-.2.2-.5.2-.7,0-.1.1-.3.1-.4-.3,2.7-.5,5.5-.5,8.4,0,39,31.3,76.3,88.1,104.8,31.7,15.9,70.8,28.5,113.2,36.5,36.2,6.8,74.4,10.3,113.6,10.3,173.6,0,314.9-68,314.9-151.6,0-2.9-.2-5.7-.5-8.4h.3c0,.4.1.8.2,1.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m588,257.89c53.7,19.6,83.2,46.4,83.2,76,0,58.3-116.9,104-266.1,104s-266.1-45.7-266.1-104c0-29.6,29.6-56.5,83.5-76.1l1,5.6c-48.7,17.9-78.9,42.9-78.9,70.6,0,54.4,116.6,98.4,260.5,98.4s260.5-44.1,260.5-98.4c0-27.6-30.1-52.6-78.6-70.4l1-5.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m587.1,263.49c48.5,17.9,78.6,42.8,78.6,70.4,0,54.4-116.7,98.4-260.5,98.4s-260.5-44.1-260.5-98.4c0-27.7,30.2-52.7,78.9-70.6l1,5.6c-47.4,17.6-74.4,41.1-74.4,65,0,50.3,116.8,92.9,255,92.9s255-42.5,255-92.9c0-23.9-26.9-47.4-74.1-64.9l1-5.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m586.1,268.99c47.2,17.5,74.1,41,74.1,64.9,0,50.3-116.7,92.9-255,92.9s-255-42.5-255-92.9c0-23.9,27-47.5,74.3-65l14,79.6v.1c0,.2.1.3.1.5.1.3.2.5.3.7.1.1.1.3.2.4.1.1.1.2.2.4.6,1,1.6,1.8,2.8,2.3.2.1.4.1.7.2,9.2,2.5,19.9,3.8,31.1,3.8s21.3-1.2,30.3-3.6c.2,0,.3-.1.5-.1h.1c.2-.1.3-.1.5-.2.6-.3,1.1-.6,1.6-1.1.1-.1.2-.2.3-.4.1-.1.2-.2.3-.4.1-.1.2-.3.3-.4.2-.3.3-.6.4-.9.1-.2.1-.3.1-.5.1-.2.1-.3.1-.5.1-.3.1-.6.1-1h0v-1l-16.9-96c35.1-6.5,74.3-10,113.8-10s78.9,3.5,114.1,10l-16.9,95.9v.9c0,.3,0,.6.1.9,0,.2.1.3.1.4s.1.3.1.4c.1.2.1.3.2.5,0,.1.1.2.1.3.1.2.2.4.3.5.1.1.1.2.2.3.3.4.7.8,1.2,1.1.1.1.2.1.3.2.2.1.3.2.5.3.1.1.2.1.3.2.2.1.4.1.6.2h.1c9,2.3,19.5,3.6,30.3,3.6s21.9-1.3,31.1-3.8c.2,0,.5-.1.7-.2.6-.2,1.1-.5,1.6-.9.2-.2.4-.4.6-.6l.1-.1c.1-.1.2-.2.3-.4.1-.1.1-.2.2-.3.1-.1.1-.2.2-.4.2-.4.3-.7.4-1.1,0-.2.1-.3.1-.5v-.1l13.8-79.1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m627.1,15.39c2.2,3.2,2.5,6.1,2.2,8.1.2-2.8-1.7-5.4-4.6-5.9-3-.5-5.9,1.5-6.4,4.5h-.1c-1.1-2.1-8.3-7.3-21.9-9.7s-22.2.1-23.9,1.7h-.1c.5-3-1.5-5.9-4.5-6.4s-5.8,1.5-6.4,4.4c.4-2,1.5-4.9,4.9-7.2,6.3-4.4,18.5-5.7,31.9-3.3,13.5,2.1,24.5,7.5,28.9,13.8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m624.8,17.49c2.8.5,4.8,3.1,4.6,5.9,0,.2,0,.3-.1.5l-.1.4c-.4,1.9-1.6,4.7-4.9,6.9-2.1,1.5-4.9,2.6-8.2,3.4l2.2-12.6c.6-3,3.5-5,6.5-4.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m629.2,24.29l-31.4,178.1c-1.5-.5-2.9-1-4.4-1.6-2.9-1-6.1.5-7.1,3.4-.1.3-.2.5-.2.8l30.1-170.4c3.3-.8,6.1-1.9,8.2-3.4,3.2-2.2,4.4-4.9,4.8-6.9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m618.4,21.99l-2.2,12.6c-3.2.7-7,1.1-11,1.1s-8.3-.4-12.7-1.2c-8.9-1.6-16.7-4.5-22.3-8.1l2.2-12.6h.1c1.1,2.1,8.3,7.4,21.9,9.8,13.6,2.4,22.2-.1,23.9-1.7l.1.1Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m616.2,34.59l-30,170.4-.1.3-9.8,55.4-14.5,82.5c-7.5,1.7-16.1,2.7-25.1,2.7-7.9,0-15.6-.7-22.5-2.1l16.9-96,9.9-56.2,29.1-165c5.6,3.6,13.4,6.5,22.3,8.1,4.4.8,8.7,1.2,12.7,1.2,4.1-.1,7.8-.5,11.1-1.3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m597.8,202.49l-2,11.1c-2-.7-4.1-1.5-6.1-2.2-2.5-.9-4-3.5-3.7-6l.1-.3c0-.3.1-.5.2-.8,1-2.9,4.2-4.4,7.1-3.4,1.5.5,2.9,1,4.4,1.6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m595.8,213.59l-7.8,44.4c-1.5-.5-2.9-1.1-4.4-1.6-2.9-1-6,.5-7,3.4-.1.3-.2.6-.2.9h0l9.8-55.4c-.4,2.6,1.1,5.1,3.7,6,1.9.8,3.9,1.5,5.9,2.3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m588,257.89l-1,5.6c-1.7-.6-3.5-1.3-5.3-1.9l-1,5.5c-.3-.1-.6-.2-.8-.3-2.6-.9-4.1-3.5-3.7-6.1.1-.3.1-.6.2-.9,1-2.9,4.2-4.4,7.1-3.4,1.6.5,3.1,1,4.5,1.5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m587.1,263.49l-1,5.5c-1.7-.6-3.5-1.3-5.3-1.9l1-5.5c1.8.6,3.5,1.3,5.3,1.9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m586.1,268.99l-14,79.5c.1-.7.1-1.5-.1-2.3-.6-2.1-2.3-3.6-4.4-4l13.3-75.1c1.7.7,3.4,1.3,5.2,1.9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m579.9,266.79c.3.1.6.2.8.3l-13.3,75.1c-.8-.1-1.6-.1-2.4.1-1.1.3-2.2.6-3.4.8l14.5-82.5h0c-.2,2.7,1.3,5.3,3.8,6.2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m570.3,592.29c3,.3,5.2,3.1,4.9,6.1-.3,3-3.1,5.3-6.1,4.9-.2,0-23.5-2.5-50.2,2.4-.2-.3-.3-.7-.5-1-2.5-5-8.1-7.5-13.4-6.2-14.5,3.4-27.3,8.6-38.1,15.3,12.6-8.4,27.9-14.5,45.6-18.2,30.2-6.3,56.7-3.4,57.8-3.3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m567.8,7.49c3,.5,5,3.4,4.5,6.4l-2.2,12.6c-2.8-1.8-5.1-3.9-6.5-6-2.4-3.4-2.5-6.6-2.1-8.6h0v-.1c.5-2.9,3.3-4.8,6.3-4.3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m571.9,346.19c.2.8.3,1.5.1,2.3v.1c0,.2-.1.3-.1.5-.1.4-.2.8-.4,1.1-.1.1-.1.2-.2.4-.1.1-.1.2-.2.3-.1.1-.2.3-.3.4l-.1.1c-.2.2-.4.4-.6.6-.5.4-1,.7-1.6.9-.2.1-.3.1-.5.1-.1,0-.2,0-.2.1-.4.1-.8.1-1.2.1-.3,0-.6,0-1-.1-2.3-.4-3.9-2.1-4.4-4.2,1.9-.4,3.7-.8,5.4-1.3l1-5.5c2,.5,3.7,2,4.3,4.1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m571.9,349.19c0-.2.1-.3.1-.5,0,.1,0,.3-.1.5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m571.3,350.59c.1-.1.1-.2.2-.4-.1.2-.2.3-.2.4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m570.8,351.29c.1-.1.2-.2.3-.4-.1.2-.2.3-.3.4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m570.7,351.39c-.2.2-.4.4-.6.6.2-.2.4-.4.6-.6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m570.1,26.49l-29.1,165h0c.7-3-1.2-5.9-4.2-6.6-1.9-.4-3.7-.8-5.6-1.2l30.3-171.8c-.4,2-.3,5.1,2.1,8.6,1.5,2.2,3.7,4.2,6.5,6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m568,352.99c.2,0,.3-.1.5-.1-.2.1-.5.2-.7.2.1,0,.2,0,.2-.1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m567.5,342.19l-1,5.5c-1.7.5-3.5.9-5.4,1.3-.2-.7-.2-1.5-.1-2.3l.6-3.5c1.1-.3,2.3-.5,3.4-.8.9-.3,1.7-.3,2.5-.2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m566.6,353.19c.4,0,.8,0,1.2-.1-9.2,2.5-19.9,3.8-31.1,3.8s-21.3-1.2-30.3-3.6h-.1c.2,0,.3.1.5.1.3.1.6.1,1,.1,2.5,0,4.8-1.8,5.4-4.3,7.1,1.4,15,2.2,23.5,2.2s17.2-.9,24.5-2.4c.5,2.1,2.2,3.8,4.4,4.2.3,0,.7,0,1,0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m561.7,343.19l-.6,3.5c-.1.8-.1,1.5.1,2.3-7.3,1.5-15.6,2.4-24.5,2.4s-16.4-.8-23.5-2.2c0-.1,0-.2.1-.3l.9-5.2c6.9,1.4,14.6,2.1,22.5,2.1,8.9.1,17.5-.9,25-2.6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m536.8,184.99c3,.7,4.9,3.6,4.2,6.6-.6,2.6-2.9,4.4-5.4,4.4-.4,0-.8,0-1.2-.1-1.7-.4-3.5-.7-5.2-1.1l1.9-10.9c1.9.3,3.8.7,5.7,1.1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m541,191.59l-9.9,56.2h0c.6-3-1.4-5.9-4.4-6.5-1.8-.4-3.7-.7-5.6-1.1l8-45.5c1.8.3,3.5.7,5.2,1.1.4.1.8.1,1.2.1,2.6,0,4.9-1.7,5.5-4.3h0Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m526.7,241.19c3,.6,5,3.5,4.4,6.5-.5,2.6-2.8,4.5-5.4,4.5-.3,0-.6,0-.9-.1l1-5.5h0c-1.8-.4-3.6-.7-5.4-1l1-5.5c1.6.4,3.5.8,5.3,1.1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m531.1,183.79l-1.9,10.9c-39.3-8.2-81-12.3-124-12.3s-84.6,4.1-123.7,12.3l-1.9-10.9c39.8-8.2,82.1-12.4,125.7-12.4,43.6-.1,85.9,4.1,125.8,12.4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m531.1,247.79l-16.9,96c-1.7-.3-3.4-.7-5-1.1-.1,0-.3-.1-.4-.1l16-90.4c.3.1.6.1.9.1,2.6-.1,4.9-1.9,5.4-4.5h0Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m525.7,246.69l-1,5.5h-.1c-1.8-.3-3.5-.7-5.3-1l1-5.5c1.7.3,3.6.6,5.4,1h0Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m524.7,252.09l-16,90.4c-2.8-.5-5.6,1.2-6.3,4.1-.1.2-.1.4-.1.6v-.1l16.9-95.9c1.8.3,3.6.7,5.3,1,.1-.1.2-.1.2-.1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m518.9,605.69c4.1,8.4,6.3,18.2,6.3,28.5,0,28.2-16.7,51.1-37.3,51.1s-37.3-22.9-37.3-51.1c0-1,0-2,.1-2.9.2-3.5,1.7-6.7,4.2-8.8,3.6-3.1,7.5-5.9,11.5-8.4-4,2.6-7.7,5.6-11,8.6-2.3,2.1-2.4,5.6-.3,7.8.3.4.7.7,1.1.9v2.8c0,25.2,14.2,45.6,31.8,45.6s31.8-20.4,31.8-45.6c0-10.1-2.3-19.5-6.2-27-.1-.1-.1-.3-.2-.4.5-.1,1-.2,1.5-.3,1.3-.3,2.6-.5,4-.8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m521.2,240.19l-1,5.5c-34.7-6.5-73.7-10.1-115-10.1s-80.1,3.6-114.8,10.1l-1-5.5c35.8-6.7,75.7-10.2,115.8-10.2s80.2,3.5,116,10.2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m520.2,245.59l-1,5.5c-35.1-6.6-74.4-10-114.1-10s-78.7,3.4-113.8,10l-1-5.5c34.6-6.4,73.6-10.1,114.8-10.1s80.4,3.6,115.1,10.1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m518.4,604.69c.2.3.3.7.5,1-1.4.2-2.7.5-4.1.8-.5.1-1,.2-1.5.3-1.4-2.4-4.3-3.6-7-3-10.7,2.6-21.7,6.4-31.9,12,0-.1-.1-.2-.2-.3-1.6-2.4-4.7-3.2-7.2-1.8,10.8-6.7,23.6-11.9,38.1-15.3,5.2-1.2,10.8,1.4,13.3,6.3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m513.5,607.19c3.9,7.5,6.2,16.9,6.2,27,0,25.2-14.3,45.6-31.8,45.6s-31.8-20.4-31.8-45.6v-2.8c.9.6,1.9.9,3,.9.9,0,1.8-.2,2.6-.6v2.5c0,21.7,12,40,26.2,40s26.2-18.3,26.2-40c0-9-1.9-17.4-5.6-24.5-.2-.4-.6-.6-1-.5-13.3,3.2-25,7.9-34.8,14h-.1c.1,0,.1-.1.2-.1,11.1-7.4,24.7-12.9,40.4-16.3.1.2.2.3.3.4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m514.2,343.79l-.9,5.2c0,.1,0,.2-.1.3-1.9-.4-3.7-.8-5.4-1.2l1-5.5c.1,0,.3,0,.4.1,1.6.3,3.3.7,5,1.1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m508.5,609.79c3.7,7,5.6,15.5,5.6,24.5,0,21.7-12,40-26.2,40s-26.2-18.3-26.2-40v-2.5c.4-.2.8-.5,1.2-.8,2.9-2.7,6.1-5.2,9.5-7.5h.4c9.8-6.1,21.5-10.8,34.8-14,.3-.3.7-.1.9.3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m513.2,349.19c-.6,2.5-2.8,4.3-5.4,4.3-.3,0-.6,0-1-.1-.2,0-.3-.1-.5-.1s-.4-.1-.6-.2c-.1-.1-.2-.1-.3-.2-.2-.1-.4-.2-.5-.3-.1-.1-.2-.1-.3-.2-.5-.3-.8-.7-1.2-1.1-.1-.1-.2-.2-.2-.3-.1-.2-.2-.4-.3-.5-.1-.1-.1-.2-.1-.3-.1-.2-.1-.3-.2-.5,0-.1-.1-.3-.1-.4s-.1-.3-.1-.4c0-.3-.1-.6-.1-.9v-.8c0-.2.1-.4.1-.6.7-2.8,3.5-4.6,6.3-4.1l-1,5.5c1.8.4,3.6.8,5.5,1.2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m506.2,603.89c2.8-.7,5.6.5,7,2.9-15.7,3.4-29.3,8.9-40.4,16.3-.1,0-.1.1-.2.1h0c2.4-1.6,3.2-4.9,1.7-7.4,10.2-5.5,21.2-9.3,31.9-11.9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m505.4,352.99c.1.1.2.1.3.2-.1-.1-.2-.2-.3-.2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m504.6,352.49c.1.1.2.1.3.2-.1-.1-.2-.1-.3-.2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m503.2,350.99c.1.1.1.2.2.3-.1,0-.2-.1-.2-.3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m502.7,350.19c0,.1.1.2.1.3,0-.1,0-.2-.1-.3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m502.4,349.29c0,.1.1.3.1.4,0-.1,0-.2-.1-.4"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m502.3,347.99c0,.3,0,.6.1.9-.1-.3-.1-.6-.1-.9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m482.6,733.59c4.4,7.4,5.3,14.2,2.7,19.1-1.9,3.9-5.3,6.6-10.2,8.2,0-.4,0-.8-.1-1.2-.1-2-.2-4.7-1.4-7.3-.4-.8-.8-1.6-1.3-2.3,1.6-.6,2.6-1.4,3.1-2.3,0-.1.1-.2.1-.3.3-.6.6-3.3-2.4-8.3-7.7-13-31.9-32.3-67.1-32.3h-.2c-35.2,0-59.4,19.3-67.1,32.3-3,5-2.8,7.7-2.4,8.3,0,.1.1.2.1.3,2.4,5.1,18.9,3.9,34.8,2.7,5.4-.4,11-.8,16.9-1.1-1.3,2-1.9,4.4-1.9,6.9,0,1.5.3,3,.8,4.3-5.2.3-10.2.6-15,1-7.7.6-14.6,1.1-20.7,1.1-12.3,0-21-2.1-24.9-10-2.6-5-1.7-11.8,2.7-19.2,14.7-24.8,49.7-37.7,76.7-37.7h.2c35.6.1,65.5,19.1,76.6,37.8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m473.1,739.29c3,5,2.8,7.7,2.4,8.3,0,.1-.1.2-.1.3-.5,1-1.5,1.7-3.1,2.3-3.8-5.4-10.8-6.7-13.2-7.2-9.6-1.9-19.2-1.7-28.2-1.2-4.4.2-8.9.4-13.3.6-4.3.2-8.7.3-13,.6h-1.8c-3.5.1-8.3.2-12.4,3.8-.9.8-1.7,1.8-2.3,2.8-5.9.3-11.5.7-16.9,1.1-15.9,1.2-32.4,2.4-34.8-2.7,0-.1-.1-.2-.1-.3-.3-.6-.6-3.3,2.4-8.3,7.7-13,31.9-32.3,67.1-32.3h.2c35.1-.1,59.3,19.2,67.1,32.2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m475,760.99c.4,7.5.8,16.6-.8,25.4-.6,3.2-1.5,7.3-4.1,10.8-2.9,3.9-7.2,6.2-11.5,6.2-.5,0-.9,0-1.4-.1-2.5-.3-4.8-1.3-6.5-2.9-1.6-1.6-2.5-3.4-3-4.7-1.6-4.1-1.8-8.3-2-12-.2-2.9-.3-5.6-1-7.9-.1.6-.3,1.3-.4,2-.2,1.1-.4,2.2-.6,3.3-1,4.3-2.7,7.5-5.2,9.8-4,3.6-9.7,4.3-14,1.6-1.9-1.2-4.5-3.7-5.5-8.8-.5-2.4-.6-4.6-.6-6.7,0-1-.1-2-.2-3-.2-2.4-.8-4.2-1.7-5.1-1.1-1.2-3.6-1.7-6.9-1.6-1.1.1-2.2.2-3.2.3-3,.3-6.4.6-10,0-2.6-.5-4.7-1.4-6.4-2.8-1.3-1.1-2.3-2.5-3-4.1,1.7-.1,3.4-.2,5.1-.2,2.6-.1,4.7-1.9,5.2-4.3v.3c.1,0,.4.1,1,.2,2,.4,4.5.1,7-.1,1.2-.1,2.5-.2,3.7-.3,6.7-.4,11.9,1.3,15.5,5,2.7,2.8,4.3,6.7,4.7,11.8.1,1.2.2,2.4.2,3.6.1,1.8.1,3.5.4,5,.2.8.3,1.2.5,1.5.2-.1.5-.2.7-.4.8-.7,1.4-2.1,1.9-4.1.2-.9.4-1.8.5-2.8.3-1.7.6-3.5,1.2-5.4.4-1.2,1.5-4.8,5-6.7,1.4-.8,2.9-1.1,4.5-1.1,2,0,4.1.6,5.8,1.8,2,1.4,3.6,3.4,4.7,6.1,1.8,4.2,2,8.6,2.2,12.5.2,3.2.3,6.1,1.3,8.6.2.6.3.7.4.7.8,0,2-.7,2.7-1.8,1.2-1.7,1.8-4.2,2.2-6.2,1.3-7.4,1.1-15,.6-24.1,0-.9-.1-1.9-.3-2.7h0c.6,2.9,3.3,4.9,6.2,4.5,1.9-.2,3.6-.6,5.1-1.1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m475,759.79c0,.4,0,.8.1,1.2-1.5.5-3.3.9-5.1,1.1-2.9.4-5.7-1.5-6.2-4.5v-.2c-.4-3,1.7-5.8,4.7-6.3,1.6-.2,2.9-.5,4-.9.5.7.9,1.4,1.3,2.2.9,2.7,1.1,5.4,1.2,7.4"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m474.3,615.89c1.5,2.5.8,5.8-1.7,7.4h0s-.1,0-.1.1h-.1c-.8.4-1.7.7-2.6.7-1.8,0-3.6-.9-4.6-2.5h0c1.4-1,2.9-1.9,4.4-2.9h0c.1-.1.2-.1.3-.2,1.4-.9,2.9-1.7,4.4-2.6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m469.5,618.69h0c-1.5.9-2.9,1.9-4.4,2.9-1.7-2.5-1-6,1.6-7.6l.1-.1.1-.1c2.5-1.3,5.6-.6,7.2,1.8.1.1.1.2.2.3-1.5.8-3,1.7-4.5,2.6-.1.1-.2.2-.3.2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m472.6,623.29h0c-.1,0-.1.1,0,0-.1.1,0,0,0,0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m472.6,623.29q-.1.1,0,0-.1.1,0,0c-.1.1-.1,0,0,0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m472.4,623.39h0c-3.6,2.2-7.1,4.8-10.4,7.6-.2.2-.3.4-.3.7-.8.4-1.7.6-2.6.6-1,0-2.1-.3-3-.9h0c.1-1.8.9-3.5,2.3-4.7,2.2-1.8,4.4-3.6,6.7-5.2h0c1.1,1.6,2.8,2.5,4.6,2.5,1,.1,1.9-.1,2.7-.6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m472.3,750.19c-1.1.4-2.4.7-4,.9-3,.4-5.1,3.3-4.7,6.3v.2h0c-.1-.3-.1-.5-.2-.7-.3-.8-1.6-2.2-6.5-3.1-8.5-1.6-17.3-1.5-25.5-1-4.5.2-9,.4-13.5.6-4.3.2-8.6.3-12.8.6-.7,0-1.4,0-2.1.1-2.6.1-4.3.1-5.2,1h0c-.2.2-.4.5-.4.8.1-.3.1-.7.1-1.1-.1-3.1-2.7-5.4-5.7-5.3-1.2,0-2.4.1-3.6.2.6-1,1.4-2,2.3-2.8,4-3.6,8.9-3.7,12.4-3.8h1.8c4.3-.2,8.6-.4,13-.6,4.4-.2,8.9-.3,13.3-.6,9-.5,18.6-.6,28.2,1.2,2.3.4,9.2,1.7,13.1,7.1"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m466.7,613.89h0q-.1.1-.2.1c.1,0,.2-.1.2-.1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m466.6,613.99s.1,0,.1-.1c-2.5,1.7-3.2,5.1-1.6,7.6-2.3,1.6-4.5,3.4-6.7,5.2-1.4,1.2-2.2,2.9-2.3,4.7h0c-.4-.3-.8-.6-1.1-.9-2.1-2.3-1.9-5.8.3-7.8,3.4-3.1,7.1-6,11-8.6.2,0,.2-.1.3-.1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m472.4,623.49c-3.4,2.3-6.6,4.8-9.5,7.5-.4.3-.8.6-1.2.8,0-.3.1-.6.3-.7,3.3-2.9,6.8-5.4,10.4-7.6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m429.1,651.59c1,1.7,1,3.8,0,5.5l-18.4,31.9c-1,1.7-2.8,2.8-4.8,2.8s-3.8-1.1-4.8-2.8l-18.4-31.9c-1-1.7-1-3.8,0-5.5s2.8-2.8,4.8-2.8h36.8c1.9.1,3.8,1.1,4.8,2.8m-23.3,23.6l8.8-15.3h-17.6l8.8,15.3Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m405.2,819.69c3.1,0,5.5,2.5,5.5,5.5s-2.3,5.4-5.3,5.5l-.3-5.5v-5.5h.1Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m405.2,825.19l.3,5.5h-.3c-144.9-.1-248-41.9-306.3-124.5-36-50.9-54-115.8-53.5-193,.3-60.3,12.6-127.6,34.5-189.7,0,.2,0,.4-.1.6v.2c-.4,3.1-.6,6.3-.6,9.6,0,6.8.8,13.4,2.4,20-16,53.2-24.9,108.8-25.1,159.4-.4,74.8,16.9,137.5,51.5,186.5,56.1,79.5,156.1,119.8,297.2,119.9v5.5h0Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m397.4,754.69c0,.4,0,.7-.1,1.1,0,.1,0,.2-.1.3h0c-.5,2.4-2.6,4.2-5.2,4.3-1.7.1-3.4.1-5.1.2-.5-1.3-.8-2.8-.8-4.3,0-2.4.6-4.8,1.9-6.9,1.2-.1,2.4-.1,3.6-.2,3.2.1,5.7,2.5,5.8,5.5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m397.4,755.79c0,.1,0,.2-.1.3,0-.1,0-.2.1-.3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m360,631.29c.1.9.1,1.9.1,2.9,0,28.2-16.7,51.1-37.3,51.1s-37.3-22.9-37.3-51.1c0-10.3,2.2-20.2,6.3-28.5,1.4.2,2.7.5,4.1.8.5.1,1,.2,1.5.3-.1.1-.1.3-.2.4-3.9,7.5-6.2,16.9-6.2,27,0,25.2,14.2,45.6,31.8,45.6s31.8-20.4,31.8-45.6c0-.9,0-1.8-.1-2.7.4-.2.8-.6,1.2-1,2.1-2.3,1.9-5.8-.4-7.8-3.6-3.3-7.4-6.2-11.4-8.9,4.2,2.5,8.2,5.5,11.9,8.7,2.6,2.3,4.1,5.4,4.2,8.8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m355.3,622.69c2.3,2.1,2.4,5.6.4,7.8-.3.4-.7.7-1.2,1h0c-.1-1.8-.9-3.5-2.2-4.7-3.7-3.1-7.6-5.9-11.6-8.4-11.4-7-23.9-11.6-36.2-14.5-2.7-.7-5.6.5-7,2.9-.5-.1-1-.2-1.5-.3-1.4-.3-2.8-.6-4.1-.8l.5-1c2.5-4.9,8-7.5,13.5-6.2,14.3,3.4,27,8.5,37.8,15.1.1.1.2.2.4.2,3.8,2.7,7.6,5.7,11.2,8.9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m354.5,631.49c.1.9.1,1.8.1,2.7,0,25.2-14.2,45.6-31.8,45.6s-31.8-20.4-31.8-45.6c0-10.1,2.3-19.5,6.2-27,.1-.1.1-.3.2-.4,15.6,3.4,29.1,8.8,40.2,16.2l.1.1c-9.8-6-21.4-10.7-34.6-13.8h-.2c-.3,0-.6.2-.8.5-3.7,7.1-5.6,15.5-5.6,24.5,0,21.7,12,40,26.2,40s26.2-18.3,26.2-40v-2.5c.8.4,1.7.7,2.6.7,1.1-.1,2.1-.4,3-1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m354.5,631.49h0c-.9.6-1.9.9-2.9.9-.9,0-1.8-.2-2.6-.7,0-.4-.1-.6-.3-.7-3.4-2.9-7-5.5-10.8-7.8,0,0-.1,0-.1-.1l-.1-.1c-11.1-7.3-24.6-12.8-40.2-16.2,1.4-2.4,4.3-3.6,7-2.9,12.2,2.9,24.8,7.5,36.2,14.5,4,2.5,7.9,5.3,11.6,8.4,1.3,1.1,2.1,2.9,2.2,4.7"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m349,631.79v2.4c0,21.7-12,40-26.2,40s-26.2-18.3-26.2-40c0-9,1.9-17.4,5.6-24.5.1-.3.5-.5.8-.5h.2c13.1,3.1,24.8,7.8,34.6,13.8,0,0,.1,0,.1.1,3.5,2.3,6.9,4.9,10,7.8.3.4.6.6,1.1.9h0"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m348.6,630.99c.2.1.3.4.3.7-.4-.2-.8-.5-1.1-.8-3.1-2.9-6.5-5.5-10-7.8,3.8,2.4,7.5,5,10.8,7.9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m343.5,613.69c-10.8-6.6-23.5-11.7-37.8-15.1-5.4-1.3-10.9,1.2-13.5,6.2l-.5,1c-26.7-4.9-50-2.4-50.2-2.4-3,.4-5.8-1.8-6.1-4.9-.3-3,1.8-5.8,4.9-6.1,1.1-.1,27.6-3,57.8,3.3,17.6,3.6,32.9,9.7,45.4,18"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m308.4,347.29v.7h0c0,.3,0,.6-.1,1,0,.2-.1.3-.1.5,0,.1-.1.3-.1.5-.1.3-.2.6-.4.9-.1.1-.2.3-.3.4s-.2.3-.3.4-.2.2-.3.4c-.4.4-1,.8-1.6,1.1-.1.1-.3.1-.5.2h-.1c-.3.1-.6.2-.9.2-.3.1-.7.1-1,.1-2.5,0-4.8-1.8-5.4-4.3,1.9-.4,3.7-.8,5.4-1.2l-1-5.5c2.8-.5,5.6,1.2,6.3,4.1.3,0,.3.2.4.5h0"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m308.3,348.99c.1-.3.1-.6.1-1,0,.3,0,.6-.1,1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m308.4,347.19c0-.2-.1-.4-.1-.6-.7-2.8-3.5-4.6-6.3-4.1l-16-90.5h.1c1.8-.3,3.6-.7,5.4-1l16.9,96c0,.1,0,.2,0,.2"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m308.2,349.39c0-.2.1-.3.1-.5,0,.2,0,.4-.1.5"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m308.1,349.89c.1-.2.1-.3.1-.5,0,.2-.1.3-.1.5"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m307.7,350.79c.2-.3.3-.6.4-.9-.1.3-.2.6-.4.9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m307.4,351.19c.1-.1.2-.3.3-.4-.1.1-.2.2-.3.4"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m307.1,351.49c.1-.1.2-.2.3-.4-.1.2-.1.3-.3.4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m306.8,351.89c.1-.1.2-.2.3-.4,0,.2-.2.3-.3.4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m305.3,352.99c.6-.3,1.1-.7,1.6-1.1-.5.4-1.1.8-1.6,1.1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m304.8,353.19c.2-.1.3-.1.5-.2-.2.1-.3.1-.5.2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m304.7,353.19c-.1.1-.3.1-.5.1-9,2.3-19.5,3.6-30.3,3.6s-22-1.3-31.1-3.8c.4.1.8.1,1.2.1.3,0,.6,0,1-.1,2.2-.4,3.9-2.1,4.4-4.2,7.3,1.5,15.7,2.4,24.5,2.4s16.4-.8,23.5-2.2c.6,2.5,2.9,4.3,5.4,4.3.3,0,.6,0,1-.1.3.1.6,0,.9-.1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m301.9,342.49l1,5.5c-1.7.4-3.5.9-5.4,1.2,0-.1,0-.2-.1-.3l-.9-5.2c1.7-.3,3.4-.7,5-1.1.1,0,.3-.1.4-.1"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m285.9,252.09l16,90.5c-.1,0-.3,0-.4.1-1.6.4-3.3.8-5,1.1l-16.9-95.9c.7,2.8,3.4,4.7,6.3,4.2"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m297.4,348.89c0,.1,0,.2.1.3-7.1,1.4-15,2.2-23.5,2.2s-17.2-.9-24.5-2.4c.2-.7.2-1.5.1-2.3l-.6-3.5c7.5,1.7,16.1,2.7,25.1,2.7,7.9,0,15.6-.7,22.5-2.1l.8,5.1Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m279.6,247.89l16.9,95.9c-6.9,1.4-14.6,2.1-22.5,2.1-8.9,0-17.5-.9-25.1-2.7l-14.5-82.5-.1-.6-9.7-55h0l-30-170.5c3.3.8,7,1.1,10.9,1.1,4.2,0,8.6-.4,12.8-1.2,8.9-1.6,16.7-4.5,22.3-8.1l29,164.4.1.7,9.8,55.6v.5c0,.2.1.2.1.3"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m290.4,245.59l1,5.5c-1.8.3-3.6.7-5.4,1h-.1l-1-5.5c1.9-.3,3.7-.7,5.5-1"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m289.5,240.09l1,5.5c-1.8.3-3.7.7-5.5,1l1,5.5c-2.9.5-5.7-1.3-6.3-4.2l-.1-.6v-.2c-.3-2.8,1.6-5.4,4.4-6,1.8-.3,3.6-.6,5.5-1"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m281.5,194.69l8,45.4c-1.9.3-3.7.7-5.6,1.1-2.8.6-4.7,3.2-4.4,6l-9.8-55.6c.7,3,3.6,4.8,6.6,4.2,1.7-.4,3.4-.8,5.2-1.1"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m279.5,183.69l1.9,10.9c-1.7.4-3.5.7-5.2,1.1-3,.6-5.9-1.2-6.6-4.2l-.1-.7c-.3-2.8,1.5-5.4,4.3-6,2-.3,3.8-.7,5.7-1.1"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m279.6,247.89c0-.1,0-.2-.1-.2v-.3l.1.5Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m249.3,12.19l30.3,171.5c-1.9.4-3.8.8-5.7,1.2-2.8.6-4.6,3.2-4.3,6l-29-164.4c2.8-1.8,5.1-3.9,6.5-6,2.3-3.3,2.5-6.3,2.2-8.3"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m249.5,346.69c.1.8.1,1.5-.1,2.3-1.9-.4-3.7-.8-5.4-1.3l-1-5.5c.8-.1,1.6-.1,2.4.1,1.1.3,2.2.6,3.4.8l.7,3.6Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m249.3,12.19c.3,2,.1,5-2.2,8.3-1.5,2.1-3.7,4.2-6.5,6l-2.2-12.6c-.5-3,1.5-5.9,4.5-6.4s5.9,1.5,6.4,4.5v.2Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m249.3,12.19v-.2c-.5-3-3.4-5-6.4-4.5s-5,3.4-4.5,6.4h-.1c-1.7-1.6-10.3-4.1-23.9-1.7-13.6,2.4-20.8,7.6-21.9,9.7h-.1c-.5-3-3.4-5-6.4-4.5-2.9.5-4.8,3.1-4.6,5.9-.3-2,0-4.9,2.2-8.1,4.4-6.3,15.5-11.7,28.9-14,13.4-2.4,25.6-1.1,31.9,3.3,3.5,2.4,4.6,5.3,5,7.3q-.1.3-.1.4"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m234.4,260.69l14.5,82.5c-1.1-.3-2.3-.5-3.4-.8-.8-.2-1.6-.3-2.4-.1l-13.2-75.3c.3-.1.6-.2.8-.3,2.6-.9,4-3.4,3.7-6"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m244.1,347.69c1.7.5,3.5.9,5.4,1.3-.5,2.1-2.2,3.8-4.4,4.2-.3.1-.6.1-1,.1s-.8,0-1.2-.1c-.1,0-.2,0-.2-.1-.1,0-.3-.1-.4-.1-1.2-.4-2.2-1.3-2.8-2.3-.1-.1-.1-.2-.2-.4-.1-.1-.1-.2-.2-.4-.1-.2-.2-.5-.3-.7,0-.2-.1-.3-.1-.5v-.1c-.1-.7-.1-1.5.1-2.3.6-2.1,2.3-3.6,4.4-4l.9,5.4Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m229.9,266.99l13.3,75.2c-2,.4-3.8,1.8-4.4,4-.2.8-.3,1.5-.1,2.3l-14-79.6c1.6-.6,3.4-1.3,5.2-1.9"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m242.6,352.99c.1,0,.2,0,.2.1-.2,0-.4-.1-.7-.2.2.1.4.1.5.1"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m238.3,13.89l2.2,12.6c-5.6,3.6-13.4,6.5-22.3,8.1-4.2.7-8.6,1.2-12.8,1.2-3.9,0-7.6-.4-10.9-1.1l-2.2-12.6h.1c1.7,1.6,10.3,4.1,23.9,1.7,13.6-2.4,20.8-7.7,21.9-9.8l.1-.1Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m239.2,350.29c.1.1.1.2.2.4-.1-.2-.2-.3-.2-.4"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m239,349.89c.1.1.1.3.2.4-.1-.1-.1-.3-.2-.4"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m238.6,348.69c0,.2.1.3.1.5,0-.2,0-.4-.1-.5"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m234.4,260.69c.4,2.6-1.1,5.1-3.7,6-.3.1-.6.2-.8.3l-1-5.5c-1.8.6-3.6,1.2-5.3,1.9l-1-5.6c1.5-.5,2.9-1.1,4.5-1.6,2.9-1,6.1.5,7.1,3.4.1.1.1.3.1.5l.1.6Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m234.3,260.09c0-.2-.1-.3-.1-.5-1-2.9-4.2-4.4-7.1-3.4-1.5.5-3,1-4.5,1.6l-7.8-44.3c2-.7,4.1-1.5,6.1-2.2,2.6-.9,4.1-3.5,3.7-6.1l9.7,54.9Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m228.9,261.49l1,5.5c-1.8.6-3.6,1.3-5.3,1.9l-1-5.6c1.7-.6,3.5-1.2,5.3-1.8"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m224.6,205.09c.4,2.6-1.1,5.2-3.7,6.1-2.1.7-4.1,1.5-6.1,2.2l-2-11.1c1.5-.5,2.9-1.1,4.4-1.6,2.9-1,6,.5,7.1,3.4.1.4.2.7.3,1h0Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m194.5,34.59l30,170.5c-.1-.3-.1-.6-.2-.9-1-2.9-4.2-4.4-7.1-3.4-1.5.5-3,1-4.4,1.6l-31.4-178.4c1,5.7,6.2,9.1,13.1,10.6"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m212.8,202.39l2,11.1c-73.6,27.1-118.7,67.6-124,111.7v-.9c0-.2,0-.3-.1-.5,0-.1,0-.2-.1-.3,0-.1-.1-.2-.1-.3-.1-.1-.1-.3-.2-.4,0-.1-.1-.2-.1-.3-.1-.2-.1-.3-.2-.4-.1-.1-.2-.3-.3-.4s-.2-.3-.3-.4-.2-.2-.3-.4c-.1-.1-.2-.2-.4-.3-.9-.8-2.1-1.2-3.5-1.2-.5,0-1.1.1-1.5.2-.2,0-.3.1-.5.2-.1,0-.2,0-.2.1-.1,0-.2.1-.3.2-.3.1-.5.3-.7.5s-.4.3-.6.6c-.1.1-.2.2-.3.3-.1.1-.2.2-.3.3-.1.1-.2.2-.2.4-.2.4-.4.8-.5,1.2v.1c0,.1-.1.2-.1.4,5.9-49,54.2-93,132.8-121.5"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m192.3,21.99l2.2,12.6c-6.9-1.6-12.1-4.9-13.1-10.6v-.1c0-.2-.1-.3-.1-.5-.3-2.8,1.7-5.4,4.6-5.9,3-.5,5.8,1.5,6.4,4.5"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m90.8,324.79h0v.7c0,.2,0,.3-.1.5,0,.3-.1.5-.2.7,0,.1-.1.2-.1.3-.9,2-2.9,3.4-5.1,3.4h-.6c-3-.3-5.1-3-4.9-6v-.2c0-.3.1-.6.2-.9v-.1c.1-.4.3-.8.5-1.2.1-.1.2-.2.2-.4.1-.1.2-.2.3-.3.1-.1.2-.2.3-.3.2-.2.4-.4.6-.6.2-.2.5-.3.7-.5.1-.1.2-.1.3-.2.1,0,.1-.1.2-.1.1-.1.3-.1.5-.2.7-.2,1.5-.3,2.2-.2,1.1.1,2,.5,2.8,1.2.1.1.3.2.4.3.1.1.2.2.3.4.1.1.2.3.3.4s.2.3.3.4.2.3.2.4c.1.1.1.2.1.3.1.1.1.3.2.4,0,.1.1.2.1.3s.1.2.1.3c0,.2.1.3.1.5.1.4.1.5.1.7"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m90.7,323.79c0,.2.1.3.1.5,0-.1,0-.3-.1-.5"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m90.8,325.39h0c0,.2,0,.4-.1.5.1-.1.1-.3.1-.5"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m90.7,323.79c0-.1,0-.2-.1-.3.1.1.1.2.1.3"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m90.7,323.49c0-.1,0-.2-.1-.3,0,.1.1.2.1.3"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m90.6,323.19c0-.2-.1-.3-.2-.4.1,0,.1.2.2.4"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m90.3,322.39c-.1-.2-.2-.3-.2-.4,0,.1.1.2.2.4"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m90,321.99c-.1-.1-.2-.3-.3-.4.2.1.3.2.3.4"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m89.8,321.59c-.1-.1-.2-.3-.3-.4.1.1.2.2.3.4"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m89.1,320.79c.1.1.2.2.3.4,0-.2-.2-.3-.3-.4"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m85.3,330.29c2.3,0,4.3-1.4,5.1-3.4-3.1,8.9-6.1,17.9-8.8,27-1.6-6.6-2.4-13.3-2.4-20,0-3.3.2-6.5.6-9.6-.2,3,1.9,5.6,4.9,6h.6"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m89.1,320.79c-.1-.1-.2-.2-.4-.3.2.1.3.2.4.3"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m88.8,320.49c-.8-.6-1.7-1-2.8-1.2-.8-.1-1.5,0-2.2.2.5-.2,1-.2,1.5-.2,1.3,0,2.5.4,3.5,1.2"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m83.8,319.49c-.2,0-.3.1-.5.2.1-.1.3-.2.5-.2"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m83.1,319.69c-.1,0-.2.1-.3.2,0-.1.2-.1.3-.2"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m82,320.39c-.2.2-.4.4-.6.6.2-.3.4-.5.6-.6"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m81.1,321.19c-.1.1-.2.2-.3.3.1,0,.2-.2.3-.3"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m80.8,321.59c-.1.1-.2.2-.2.4,0-.2.1-.3.2-.4"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m79.9,323.59c0-.1.1-.2.1-.4-.1.3-.1.6-.2.9v.2-.2c0-.1,0-.3.1-.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m34.3,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m76.8,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m119.3,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m161.7,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m204.2,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m246.7,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m289.2,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m331.7,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m374.1,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m416.6,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m459.1,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-104"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m501.6,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-98"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m544,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-97"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m586.5,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m629,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-100"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m671.5,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-102"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m713.9,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m756.4,385.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m15.3,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-103"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m57.8,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m100.2,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8c3,.1,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m142.7,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m185.2,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m227.7,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8c2.9.1,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m270.1,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m312.6,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m355.1,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m397.6,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m440,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m482.5,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m525,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m567.5,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m609.9,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m652.4,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m694.9,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m737.4,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m779.8,440.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8c3,.1,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m34.3,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m76.8,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m119.3,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m161.7,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m204.2,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m246.7,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m289.2,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m331.7,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m374.1,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m416.6,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m459.1,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m501.6,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m544,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m586.5,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m629,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m671.5,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m713.9,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m756.4,492.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m15.3,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m57.8,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m100.2,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m142.7,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-84"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m185.2,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m227.7,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m270.1,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-80"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m312.6,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-86"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m355.1,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m397.6,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m440,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-87"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m482.5,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-82"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m525,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m567.5,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m609.9,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m652.4,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-92"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m694.9,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-90"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m737.4,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-83"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m779.8,547.59c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-94"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m34.3,599.39c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8c2.9,0,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m76.8,599.39c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m119.3,599.39c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-93"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m161.7,599.39c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8c3,0,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m204.2,599.39c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m374.1,599.39c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8c3,0,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m416.6,599.39c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8c2.9,0,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m459.1,599.39c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m629,599.39c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8c2.9,0,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m671.5,599.39c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m713.9,599.39c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m756.4,599.39c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m15.3,654.29c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m57.8,654.29c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m100.2,654.29c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m142.7,654.29c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m185.2,654.29c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m227.7,654.29c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m270.1,654.29c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m567.5,654.29c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m609.9,654.29c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m652.4,654.29c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m694.9,654.29c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m737.4,654.29c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m779.8,654.29c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.7,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m34.3,706.09c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-137"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m76.8,706.09c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m119.3,706.09c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m161.7,706.09c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m204.2,706.09c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-142"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m246.7,706.09c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-136"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m289.2,706.09c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m544,706.09c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m586.5,706.09c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-144"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m629,706.09c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-141"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m671.5,706.09c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-129"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m713.9,706.09c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-128"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m756.4,706.09c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-127"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m15.3,760.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-126"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m57.8,760.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-131"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m100.2,760.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-130"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m142.7,760.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-132"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m185.2,760.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-133"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m227.7,760.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-134"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m270.1,760.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m312.6,760.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m525,760.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-163"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m567.5,760.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m609.9,760.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-164"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m652.4,760.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-165"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m694.9,760.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m737.4,760.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-160"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m779.8,760.99c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-166"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m34.3,812.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-167"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m76.8,812.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m119.3,812.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-153"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m161.7,812.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-157"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m204.2,812.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-151"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m246.7,812.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-154"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m289.2,812.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-155"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m331.7,812.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-150"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m374.1,812.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m416.6,812.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-152"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m501.6,812.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-149"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m544,812.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-156"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m586.5,812.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-119"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m629,812.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m671.5,812.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m713.9,812.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-116"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m756.4,812.79c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-106"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m15.3,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-115"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m57.8,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m100.2,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-117"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m142.7,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-113"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m185.2,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-118"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m227.7,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-125"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m270.1,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m312.6,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-121"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m355.1,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m397.6,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-109"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m440,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-123"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m482.5,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m525,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-108"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m567.5,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m609.9,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-124"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m652.4,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-147"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m694.9,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-146"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m737.4,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m779.8,867.69c0,12-2.4,21.8-5.3,21.8s-5.3-9.8-5.3-21.8,2.4-21.8,5.3-21.8,5.3,9.8,5.3,21.8"
  })))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m86,955.79c6.5-6.1,14.8-9.6,21.6-15.5,1.1-.2,2.2-.4,3.6-.4,4.5,0,9.4,1.8,12.6,5.2,3.8,19.8,10.6,56.6,20.4,74.1.7,7.4-8.8,7.4-13.5,7.4-3.4,0-6.3-.7-7.9-4-6.7-16.4-13.9-40-17.1-57.5-.5-.5-.9-.9-1.6-.9-1.1,0-2.7,1.8-3.8,2.5-8.8,11.7-17.5,24.5-24.5,37.3-1.8,3.6-3.6,7.9-7.9,9.2-2,.7-4,1.1-6.3,1.1-1.6,0-4.5-.5-5.8-1.8-2.5-2.7-13-31.4-14.6-36.6-.9-2.7-.7-5.6-3.4-7.4-6.3,9.7-11.4,20-15.9,30.8-1.4,2.9-4.9,13.5-6.3,15.5-1.1,1.8-4.7,2-6.7,2h-1.7c-2.9-1.1-5.2-4-7.2-6.5,1.1-8.8,5.6-16.6,9-24.7,4.7-11,11.5-20.9,17.1-31.4,1.8-3.6,3.6-7.2,4.9-10.8.5-1.6.9-3.6,1.6-4.9,1.6-3.4,5.8-6.3,9.4-6.3,8.5,0,12.1,13.5,13.2,20.2,1.1,7.2,6.5,24,9.7,30.8,8-8.3,12.5-19.3,21.1-27.4"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m280.2,1015.69c.2,3.1-2.2,6.1-4.9,7.6-3.4,0-6.3.7-9.6.7-1.4,0-3.1-.2-4.5-.7-4.3-2.2-14.6-25.4-21.3-30.3-7-.7-13.7-.9-20.7-.9-4.7,0-9.2.2-13.9.2-4,6.7-8.3,13.2-12.1,20-1.8,3.4-3.4,8.3-5.4,11.2-1.8,2.7-6.3,6.5-9.7,6.5-4.7,0-9.2-6.3-9.6-10.8,3.8-9.2,9.2-17.5,13.2-26.7,6.5-15.7,15-30.5,21.1-46.5,3.1-7.6,7-17.5,16.8-17.5,1.1,0,2.5.5,3.6.7,5.4.5,9.2.2,11.9,5.8,5.2,11.2,11.4,22.4,17.5,33.4,4.3,7.9,8.5,16.2,13.2,23.8,1.6,2.5,3.6,4.9,5.2,7.4,3.1,4.9,6.1,10.1,9.2,15.3v.8Zm-69-42.7c2.7,1.3,7.4,1.6,10.3,1.6,4.7,0,9.4-.4,14.1-1.1-2.9-5.6-8.8-16.4-13.5-20.4-4.1,4.9-9.7,13.6-10.9,19.9"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m325.8,1037.39c-3.1,1.3-6.3,3.4-9.9,3.4-15.3,0-11.9-27.4-11.9-37.3v-1.6c0-22,.2-28.5-1.1-50.5-.2-4.7-.7-9.4-.7-13.9s.5-12.3,4.3-15.5c1.8-1.6,5.6-4.3,8.1-4.3s3.8,1.4,5.8,2.5c14.6,8.5,28.7,17.5,39.3,31.2,11.7,14.6,18.6,17.5,18.6,36.1,0,36.7-22.5,35.5-52.5,49.9m-3.2-82.8c0,15,1.3,14.3,1.3,29.6,0,3.6-.2,7.2-.2,10.8,0,12.1.7,8.5,1.1,20.6,16.6-3.4,32.6-13,32.6-28.9,0-19.8-18.4-30.1-34.6-40.6,0,2.7-.2,5.6-.2,8.5"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m467,932.79c0,13-41.5,8.8-41.5,48.7,0,8.3,2.9,23.3,9.9,29,11.2,8.8,35.9.9,35.9,13.5,0,10.1-15.5,11.2-22.7,11.2-12.8,0-29-6.7-35.5-18.4-5.8-10.3-8.3-23.8-8.3-35.7,0-13.2,3.4-32.3,14.1-41.3,8.8-7.6,22.2-16.4,34.3-16.4,3.8,0,7.6.9,10.8,2.9.9,1.1,2.2,2.2,2.2,3.6.5.9.8,1.8.8,2.9"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m573.2,1000.69c-7.4,12.3-26.7,27.6-41.5,27.6-1.1,0-2.2-.2-3.4-.5-22.5-4.3-33.7-21.1-33.7-43.3,0-9.9,2-24.2,8.3-32.1,9-11.2,26.5-22.2,41.3-22.2s22.5,1.4,31.4,13.9c4.7,6.5,5.8,15.5,5.8,23.4.1,10.8-2.4,23.8-8.2,33.2m-51.9-41.3c-5.2,5.2-7,17.3-7,24,0,12.6,7,23.3,20.7,23.3,18.2,0,27.8-18.4,27.8-34.6,0-4.9-.9-13.5-5.2-16.8-4.9-4-11-6.1-17.3-6.1-6,.1-15,6.4-19,10.2"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m669.9,932.79c0,13-41.5,8.8-41.5,48.7,0,8.3,2.9,23.3,9.9,29,11.2,8.8,35.9.9,35.9,13.5,0,10.1-15.5,11.2-22.7,11.2-12.8,0-29-6.7-35.5-18.4-5.8-10.3-8.3-23.8-8.3-35.7,0-13.2,3.4-32.3,14.1-41.3,8.8-7.6,22.2-16.4,34.3-16.4,3.8,0,7.6.9,10.8,2.9.9,1.1,2.2,2.2,2.2,3.6.6.9.8,1.8.8,2.9"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m776.1,1000.69c-7.4,12.3-26.7,27.6-41.5,27.6-1.1,0-2.2-.2-3.4-.5-22.5-4.3-33.7-21.1-33.7-43.3,0-9.9,2-24.2,8.3-32.1,9-11.2,26.5-22.2,41.3-22.2s22.5,1.4,31.4,13.9c4.7,6.5,5.8,15.5,5.8,23.4.1,10.8-2.3,23.8-8.2,33.2m-51.8-41.3c-5.2,5.2-7,17.3-7,24,0,12.6,7,23.3,20.7,23.3,18.2,0,27.8-18.4,27.8-34.6,0-4.9-.9-13.5-5.2-16.8-4.9-4-11-6.1-17.3-6.1-6,.1-15,6.4-19,10.2"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m730.4,322.89c-.1-.2-.1-.4-.2-.5-6.6-48.2-54.7-91.6-132.5-120l31.4-178.1.1-.4c0-.2.1-.3.1-.5.3-2,0-4.9-2.2-8-4.4-6.3-15.5-11.7-28.8-14.1-13.4-2.4-25.6-1.1-31.9,3.3-3.4,2.4-4.6,5.2-4.9,7.2v.1h0l-30.3,171.8c-39.9-8.3-82.3-12.5-125.9-12.5s-85.8,4.2-125.7,12.4L249.3,12.09v-.2c-.4-2-1.5-4.9-5-7.3-6.3-4.4-18.5-5.7-31.9-3.3s-24.4,7.7-28.8,14.1c-2.2,3.2-2.5,6.1-2.2,8.1,0,.2,0,.3.1.5v.1l31.4,178.4c-78.6,28.5-127,72.5-133,121.2-22.1,61.9-34.4,129.3-34.7,189.5-.4,77.1,17.6,142.1,53.5,193,58.3,82.6,161.4,124.5,306.3,124.5h.3c144.9-.1,248-41.9,306.3-124.5,36-50.9,54-115.9,53.6-193-.4-60.5-12.7-128-34.8-190.3m-144.4-117.9l-.1.3-9.8,55.4-14.5,82.5c-7.5,1.7-16.1,2.6-25.1,2.6-7.9,0-15.6-.7-22.5-2.1l16.9-96,9.9-56.2,29.1-165c5.6,3.6,13.4,6.5,22.3,8.1,4.4.8,8.8,1.2,12.7,1.2s7.7-.4,11-1.1l-29.9,170.3Zm10.2-192.7c13.6,2.4,20.8,7.6,21.9,9.7-1.7,1.6-10.3,4.1-23.9,1.7-13.6-2.4-20.8-7.7-21.9-9.8,1.8-1.6,10.3-4.1,23.9-1.6m-191.2,170.1c43.1,0,84.8,4.1,124,12.3l-8,45.5c-35.8-6.7-75.8-10.2-116-10.2s-80,3.5-115.7,10.1l-8-45.4c39.2-8.2,80.8-12.3,123.7-12.3M214.1,12.29c13.6-2.4,22.2.1,23.9,1.7-1.1,2.1-8.3,7.4-21.9,9.8-13.6,2.4-22.2-.1-23.9-1.7,1.1-2.2,8.3-7.5,21.9-9.8m-19.7,22.3c3.3.8,7,1.1,10.9,1.1,4.2,0,8.6-.4,12.8-1.2,8.9-1.6,16.7-4.5,22.3-8.1l29,164.4.1.7,9.8,55.6v.5c0,.1,0,.2.1.2l16.9,95.9c-6.9,1.4-14.6,2.1-22.5,2.1-8.9,0-17.5-.9-25.1-2.6l-14.5-82.5-.1-.6-9.7-55h0l-30-170.5Zm20.2,178.9l7.8,44.3c-53.9,19.6-83.5,46.5-83.5,76.1,0,58.3,116.9,104,266.1,104s266.1-45.7,266.1-104c0-29.5-29.5-56.4-83.2-76l7.8-44.4c73.6,27.1,118.6,67.7,123.7,111.9.3,2.7.5,5.6.5,8.4,0,83.6-141.3,151.6-314.9,151.6-39.2,0-77.4-3.4-113.6-10.3-42.4-7.9-81.5-20.6-113.2-36.5-56.8-28.5-88.1-65.7-88.1-104.8,0-2.9.2-5.7.5-8.4v-.4c5.4-44,50.4-84.5,124-111.5m488,486.3c-56.1,79.5-156.2,119.8-297.2,119.9h-.3c-141.1-.1-241.1-40.4-297.2-119.9-34.6-49-51.9-111.8-51.5-186.5.3-50.6,9.1-106.2,25.2-159.4,8.7,35.9,40.5,68.9,91.8,94.7,32.6,16.4,72.8,29.3,116.1,37.5,36.9,6.9,75.8,10.5,115.7,10.5,86.4,0,167.8-16.5,229-46.6,53.2-26.1,86.1-59.9,94.7-96.6,16.1,53.3,25,109.2,25.3,159.9.3,74.8-17,137.5-51.6,186.5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m570.2,592.29c-1.1-.1-27.6-3-57.8,3.3-17.7,3.7-33,9.8-45.6,18.2l-.1.1h0c-.1,0-.1.1-.2.1s-.1.1-.2.1c-4,2.5-7.9,5.3-11.5,8.4-2.5,2.1-4.1,5.3-4.2,8.8,0,1-.1,1.9-.1,2.9,0,28.2,16.7,51.1,37.3,51.1s37.3-22.9,37.3-51.1c0-10.3-2.2-20.2-6.3-28.5,26.7-4.9,49.9-2.4,50.2-2.4,3.1.4,5.8-1.8,6.1-4.9.3-3-1.9-5.7-4.9-6.1"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m405.8,695.89h-.2c-27,0-61.9,12.9-76.7,37.7-4.4,7.4-5.3,14.2-2.7,19.2,3.9,7.9,12.6,10,24.9,10,6.1,0,13-.5,20.7-1.1,4.9-.4,9.9-.7,15.1-1,.6,1.6,1.6,3,2.9,4.1,1.7,1.4,3.8,2.3,6.4,2.8,3.5.6,7,.3,10,0,1.1-.1,2.2-.2,3.2-.3,3.3-.2,5.7.4,6.9,1.6.9.9,1.4,2.6,1.7,5.1.1,1,.1,2,.2,3,.1,2.2.2,4.4.6,6.8,1,5.1,3.6,7.6,5.5,8.8,4.2,2.6,10,2,14-1.6,2.5-2.3,4.3-5.5,5.2-9.8.3-1.1.5-2.2.6-3.3.1-.7.2-1.4.4-2,.7,2.3.9,5,1,7.9.2,3.7.4,7.9,2,12,.5,1.3,1.3,3.1,3,4.7,1.7,1.6,4,2.7,6.5,3,.5.1.9.1,1.4.1,4.3,0,8.7-2.3,11.5-6.2,2.6-3.5,3.6-7.6,4.1-10.8,1.6-8.8,1.2-17.9.8-25.4,5-1.6,8.3-4.3,10.2-8.2,2.6-5,1.7-11.8-2.7-19.1-11-19-40.9-38-76.5-38m57.4,88.5c-.4,2-.9,4.5-2.2,6.2-.8,1-1.9,1.7-2.7,1.8,0,0-.1-.2-.4-.7-.9-2.4-1.1-5.4-1.3-8.6-.2-3.9-.4-8.3-2.2-12.5-1.1-2.7-2.7-4.8-4.7-6.1-1.7-1.2-3.8-1.8-5.8-1.8-1.6,0-3.1.4-4.5,1.1-3.5,1.9-4.6,5.6-5,6.8-.6,1.9-.9,3.7-1.2,5.4-.2.9-.3,1.9-.5,2.8-.5,2-1.1,3.4-1.9,4.1-.2.2-.5.3-.7.4-.1-.2-.3-.7-.5-1.5-.3-1.5-.4-3.2-.4-5,0-1.2-.1-2.4-.2-3.6-.4-5.1-2-9-4.7-11.8-3.5-3.7-8.7-5.3-15.4-5-1.2.1-2.5.2-3.7.3-2.5.2-4.9.5-7,.1-.6-.1-.9-.2-1-.2v-.3h0c0-.1,0-.2.1-.3.1-.3.2-.6.4-.8h0c.9-.8,2.6-.9,5.2-1,.7,0,1.4,0,2.1-.1,4.3-.2,8.6-.4,12.8-.6,4.5-.2,9-.3,13.4-.6,8.3-.4,17-.6,25.5,1,4.8.9,6.1,2.4,6.5,3.1.1.2.2.4.2.7.2.8.2,1.8.3,2.7.6,9.1.8,16.6-.5,24m12.1-36.8c0,.1-.1.2-.1.3-.5,1-1.5,1.7-3.1,2.3-3.8-5.4-10.8-6.7-13.2-7.2-9.6-1.9-19.2-1.7-28.2-1.2-4.4.2-8.9.4-13.3.6-4.3.2-8.7.3-13,.6h-1.8c-3.5.1-8.3.2-12.4,3.8-.9.8-1.7,1.8-2.3,2.8-5.9.3-11.5.7-16.9,1.1-15.9,1.2-32.4,2.4-34.8-2.7,0-.1-.1-.2-.1-.3-.3-.6-.6-3.3,2.4-8.3,7.7-13,31.9-32.3,67.1-32.3h.2c35.2,0,59.4,19.3,67.1,32.3,3,4.9,2.8,7.6,2.4,8.2"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m400.9,689.09c1,1.7,2.8,2.8,4.8,2.8s3.8-1.1,4.8-2.8l18.4-31.9c1-1.7,1-3.8,0-5.5s-2.8-2.8-4.8-2.8h-36.8c-2,0-3.8,1-4.8,2.8-1,1.7-1,3.8,0,5.5l18.4,31.9Zm13.6-29.1l-8.8,15.3-8.8-15.3h17.6Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m359.9,634.29c0-1.1,0-2.1-.1-2.9-.1-3.4-1.6-6.6-4.2-8.8-3.8-3.2-7.8-6.1-11.9-8.7-.1-.1-.2-.2-.4-.2-12.5-8.3-27.8-14.3-45.4-18-30.2-6.3-56.7-3.5-57.8-3.3-3,.3-5.2,3.1-4.9,6.1s3.1,5.2,6.1,4.9c.2,0,23.5-2.5,50.2,2.4-4.1,8.4-6.3,18.2-6.3,28.5,0,28.2,16.7,51.1,37.3,51.1,20.7,0,37.4-22.9,37.4-51.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadcocoLogo2);
export default __webpack_public_path__ + "static/media/madcoco_logo_2.18e10b8a89c2ee1780ae75abc0cd3a8c.svg";
export { ForwardRef as ReactComponent };